import React from "react"
import { CartelasFornecedorContextProvider } from "./context/CartelasFornecedorContextProvider"
import { CartelasFornecedor } from "./CartelasFornecedor"

export function Index() {
    return (
        <CartelasFornecedorContextProvider>
            <CartelasFornecedor />
        </CartelasFornecedorContextProvider>
    )
}
